import PropTypes from 'prop-types';

export const GeckoPaginationModel = {
  total_items: PropTypes.number,
  current_page: PropTypes.number,
  total_pages: PropTypes.number,
  order_by: PropTypes.string,
  sort: PropTypes.string,
  chnagePage: PropTypes.func,
  changeOrder: PropTypes.func,
};
